import type { TilesConfig } from '~/store2/layers';
import { TOCLabelMap, TOCLegendParentMap } from '~/store2/TOCLayers';
import { PERMITTING_VISIBLE_UTILITY_LAYER_IDS } from './permittingEmbedLayers';

export type PermitLegendRowModel = {
  label: string;
  imageData: string;
  width: number;
  height: number;
};

export type PermitLegendBlockModel = {
  layerId: string;
  title: string;
  rows: PermitLegendRowModel[];
};

/**
 * Utility legend blocks for permitting layers that appear in `includedLayerIds` (typically
 * map-query source ids from `getCurrentlyVisibleLegendLayerIds`, in TOC order).
 */
export function getVisiblePermittingLegendModels(
  tilesConfig: TilesConfig | null | undefined,
  includedLayerIds: Iterable<string>,
): PermitLegendBlockModel[] {
  if (!tilesConfig) {
    return [];
  }
  const visible = new Set(includedLayerIds);
  const blocks: PermitLegendBlockModel[] = [];

  for (const id of PERMITTING_VISIBLE_UTILITY_LAYER_IDS) {
    if (!visible.has(id)) continue;
    const config = tilesConfig[id];
    if (!config?.legend?.length) continue;

    const title = TOCLegendParentMap.get(id) ?? TOCLabelMap.get(id) ?? id;
    blocks.push({
      layerId: id,
      title,
      rows: config.legend.map((leg) => ({
        label: leg.label || TOCLabelMap.get(id) || '',
        imageData: leg.imageData,
        width: leg.width,
        height: leg.height,
      })),
    });
  }

  return blocks;
}
